(ns frontend.view.settings.sys-admin.components.feature
  (:require
   [common.localization :as loc]
   [common.features.plan :as plan]
   [frontend.utils :as fu]
   [frontend.view.settings.sys-admin.db :as db]
   [frontend.view.settings.sys-admin.events :as events]
   [reagent.core :as r]
   [ui.components.toggle.view :as toggle]))

(defn in-use-cell
  [{:keys [current-plan old-value modified-state
           feature-key setting-key disable-toggle?]}]
  (let [default-value (some-> plan/default-plans
                              (get current-plan)
                              :features
                              feature-key
                              setting-key)
        old-value (or old-value default-value)
        new-value (-> @modified-state
                      setting-key)
        on-change (partial events/modify-plan modified-state setting-key)
        checked (= :in-use old-value)
        new-checked (not= :not-in-use new-value)]
    [:div
     [:div
      {:class "flex items-center justify-end gap-2"}
      [toggle/toggle
       {:checked?   checked
        :on-change (fn [_]
                     (when-not disable-toggle?
                       (on-change (if checked :not-in-use :in-use))))
        :disabled  disable-toggle?}]
      (when (and new-value (not= old-value new-value))
        [:<>
         [:i.fal.fa-chevron-right]
         [toggle/toggle
          {:checked?   new-checked
           :on-change (fn [update-checked]
                        (if (= update-checked checked)
                            (events/undo-modification modified-state setting-key)
                            (on-change (if update-checked :in-use :not-in-use))))}]])]]))

(defn plan-view
  [tenant current-plan]
  (let [selected-plan (or (:plan/type @db/modified-plan)
                          (:plan/type current-plan))]
    [:div
     {:class "py-3 flex justify-between"}
     [:div 
      {:class "font-bold"}
      (loc/tr :plan)]
     [:div
      {:class "text-right"}
      [:select.settings-form-select
       {:value     (subs (str selected-plan) 1)
        :on-change #(events/set-plan tenant
                                     (keyword (-> %
                                                  .-target
                                                  .-value)))}
       (doall (for [v (keys plan/default-plans)]
                [:option
                 {:key   v
                  :value (subs (str v) 1)}
                 (loc/tr v)]))]]]))

(defn view
  [{:keys [tenant modified-state feature-key config]}]
  (let [current-plan (-> tenant
                         :tenant/product-plan)
        {:keys [tooltip disabled?]} config
        old (-> current-plan
                :features
                feature-key)]
    [:div
     {:class "p-3 flex justify-between border border-solid border-base-light-border-paler rounded"}
     [:div (loc/tr feature-key)]
     [fu/tooltip-overlay-if
      {:id        (str (name feature-key) "-info-tooltip")
       :placement "left"}
      tooltip
      tooltip
      (in-use-cell {:current-plan    current-plan
                    :old-value       (:status old)
                    :modified-state  (r/cursor modified-state [feature-key])
                    :feature-key     feature-key
                    :setting-key     :status
                    :disable-toggle? disabled?})]]))
